import POIStep from "@/components/POI/POIStep/POIStep.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import POIImagePreview from "@/components/POI/POIImagePreview/POIImagePreview.vue";
import { uploadFile } from "@/helpers/fileHelper";
import { getImageDimensionSizes } from "@/helpers/commonHelper";

export default {
  name: "PoiContactPerson",
  components: { POIImagePreview, InfoDialog, POIStep },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    salutations: [
      { value: "", title: "Keine Angabe" },
      { value: "male", title: "Herr" },
      { value: "female", title: "Frau" },
      { value: "maleAndFemale", title: "Herr und Frau" },
      { value: "diverse", title: "Divers" },
      { value: "family", title: "Familie" }
    ],
    mainDialog: false,
    mainDragging: false
  }),
  methods: {
    async addDropFile(e) {
      let file = e?.dataTransfer?.files ?? e ?? [];
      if (!this.editedItem.contactPerson) {
        this.editedItem.contactPerson = {
          name: "",
          eMail: "",
          phoneNumber: "",
          mobileNumber: "",
          picture: {}
        };
      }
      this.editedItem.contactPerson.picture = file;

      const data = await uploadFile(
        file,
        this.editedItem.id || this.editedItem._id,
        "pois",
        this.editedItem.principal,
        progressEvent => {
          this.$store.dispatch(
            "createSuccess",
            Math.round((progressEvent.loaded * 100) / progressEvent.total) +
              " % hochgeladen.."
          );
        }
      );

      if (!data.imageSizes && data.url) {
        data.imageSizes = await getImageDimensionSizes(data.url);
      }
      if (!data.showIn) {
        data.showIn = "gallery";
      }
      data.fit_cover = true;

      this.editedItem.contactPerson.picture = data;
      this.$emit("save", false);
    },
    removeFile(id) {
      this.$emit("addToDestroyList", id);
      this.editedItem.contactPerson.picture = {};
    },
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  },
  computed: {
    mainFile() {
      return this.editedItem.contactPerson?.picture;
    }
  }
};
